<template>
    <div class="step">
        <h1 class="step__question">What else are you seeking in your beauty regimen?</h1>

        <ul class="step__answers-wrapper">
            <li v-for="(benefit,i) in options" class="step__answer --benefit" :key="i">
                <div class="answer-wrapper" @click="concern = i" :class="{ '--chosen': concern === i }">
                    <div class="answer">
                        <SunProtection v-if="benefit === 'Sun Protection'" />
                        <Lifting v-if="benefit === 'Lifting'" />
                        <Firming v-if="benefit === 'Firming'" />
                        <WrinkleCorrecting v-if="benefit === 'Wrinkle Correcting'" />
                        <Brightening v-if="benefit === 'Brightening'" />
                        <Cleansing v-if="benefit === 'Cleansing'" />
                        <Glow v-if="benefit === 'Glow'" />
                    </div>
                    <p class="answer__text">{{ benefit }}</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { bus } from '../../utilities'
import logic from '../../data/logic'
import SunProtection from '../icons/sun-protection.vue'
import Lifting from '../icons/lifting.vue'
import Firming from '../icons/firming.vue'
import WrinkleCorrecting from '../icons/wrinkle-correcting.vue'
import Brightening from '../icons/brighten.vue'
import Cleansing from '../icons/cleansing.vue'
import Glow from '../icons/glow.vue'

export default {
    name: 'Benefits',
    components: {
        SunProtection, Lifting, Firming, WrinkleCorrecting, Brightening, Cleansing, Glow
    },
    data() {
        return {
            options: logic.quiz[5].options,
            concern: null
        }
    },
    watch: {
        concern() {
            this.answer(this.concern)
        }
    },
    methods: {
        answer(i) {
            bus.$emit('answer::chosen', i)
        }
    }
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/sections/benefits.vue